import { useCallback, useContext, useEffect, useState } from "react";
import Context from "../Context/UserContext";
import loginService from "../services/Identity.API/ServiceLogin";
import { isExpired } from "react-jwt";
import { CLAIM_CODCUSTOMER, CLAIM_PERSONA_ID, CLAIM_ROLE, getAccessLocalStorage, keyAccess, validateRole } from "../Utils/RoleHelper";

export default function useUser() {
  const { jwt, setJWT, onMsalInstanceChange } = useContext(Context);
  const [state, setState] = useState({ loadind: false, error: false });

  const [access, setAccess] = useState(getAccessLocalStorage);

  /* useEffect(() => {
    if (access) {
        localStorage.setItem("Access", JSON.stringify(access));
        console.log("access",access)
    } else {
        localStorage.removeItem("Access");
        console.log("adfsdfds")
    }
}, [access]); */

  /* useEffect(() => {
    if (jwt) {
      //localStorage.setItem(keyJwt, `"${token}"`);
      let t = JSON.parse(atob(jwt.split(".")[1]));
      setAccess({
        ...access,
        personaId: t[CLAIM_PERSONA_ID],
        role: validateRole(t[CLAIM_ROLE]),
        codCustom: t[CLAIM_CODCUSTOMER],
      });
    } else {
      localStorage.removeItem(jwt);
    }
  }, [jwt]); */

  const login = useCallback(
    (modelLogin) => {
      setState({ loading: true, error: false });
      loginService
        .login(modelLogin)
        .then((response) => {
          if (response.status === 200) {
            let token = response.data.accessToken;
            if (token === "undefined" || token === undefined) {
              window.location.href = "/login";
              window.localStorage.removeItem("jwt");
              window.localStorage.removeItem("username");
            } else {
              setJWT(token);
              let t = JSON.parse(atob(token.split(".")[1]));
              console.log("t", t)
              let obj =
              {
                personaId: t[CLAIM_PERSONA_ID],
                role: validateRole(t[CLAIM_ROLE]),
                codCustom: t[CLAIM_CODCUSTOMER],
              }
              setAccess(obj);
              console.log("access", access)
              window.localStorage.setItem("jwt", token);
              window.localStorage.setItem(keyAccess , JSON.stringify(obj) );
              setState({ loading: false, error: false });
              window.location.href = "/cuadrodemando";
            }
          }
        })
        .catch((err) => {
          setState({ loading: false, error: true });
          console.error("error", err);
        });
    },
    [jwt, setJWT]
  );
  const loginMicrosoft = useCallback(
    (modelLogin, msal) => {
      let isMounted = true;
      setState({ loading: true, error: false });
      onMsalInstanceChange(msal);
      loginService
        .loginMicrosoft(modelLogin)
        .then((response) => {
          if (!isMounted) return; 
          if (response.status === 200) {
            let token = response.data.accessToken;
            console.log("token", token)
            if (token === "undefined" || token === undefined) {
              window.location.href = "/login";
              window.localStorage.removeItem("jwt");
              window.localStorage.removeItem("username");
            } else {
              setJWT(token);
              let t = JSON.parse(atob(token.split(".")[1]));
              //console.log("access", t)
              window.localStorage.setItem("jwt", token);
              let obj =
              {
                personaId: t[CLAIM_PERSONA_ID],
                role: validateRole(t[CLAIM_ROLE]),
                codCustom: t[CLAIM_CODCUSTOMER],
              }
              window.localStorage.setItem(keyAccess , JSON.stringify(obj) );
              //console.log("obj", obj)
              setAccess(obj);
              //window.localStorage.setItem("Access", access);
              setState({ loading: false, error: false });
              window.location.href = "/cuadrodemando";
              //console.log("lllll")
            }
            //console.log("first")
          }
        })
        .catch((err) => {
          setState({ loading: false, error: true });
          console.error("error", err);
        });
    },
    [jwt, setJWT]
  );

  const logout = useCallback(() => {
    setJWT(null);
    setAccess(null)
    window.localStorage.removeItem("jwt");
    // console.log(keyAccess)
    window.localStorage.removeItem("Access");
    sessionStorage.clear();
  
  }, [jwt, setJWT, access, setAccess]);





  const expiredToken = useCallback(() => {
    let isExp = isExpired(jwt);
    if (isExp === true) {
      window.localStorage.removeItem("jwt");
      window.localStorage.removeItem(keyAccess);

      window.location.reload();
    }
  });

  const getToken = () => {
    let c = localStorage.getItem("jwt");
    //si la clave JWT no existe devuelve  null
    if (c && c !== "") {
      return c.substring(1, c.length - 1);
    }
    return null;
  };

  const getInfoToken = (key) => {
    let s = getToken();
    if (s) {
      let t = JSON.parse(Buffer.from(s.split(".")[1], "base64").toString());
      return t[key];
    }
    return null;
  };

  return {
    token: jwt,
    isLoginLoading: state.loading,
    hasLoginError: state.error,
    login,
    logout,
    expiredToken,
    loginMicrosoft,
    getInfoToken,
  };
}
